import React from 'react';
import { Field } from 'react-final-form';

//Components
import { campotexto } from '../campos/campos';

//TOOLS
import { getTraducaoTrocaPor as trad } from '../../../utils/getTraducoes';

class FormNovaSenha extends React.Component {
    
    render(){        
        return (
            <>
                <Field type='password' name='senha' label={trad(this.props.trads,'CONF_SENHA',this.props.lingua)} component={campotexto} />
            </>
        )
    }
}

export default FormNovaSenha;